/* ============================================================
   eMazzanti micro-sites — SHARED CHROME behaviour
   Header scroll-darkening + mobile drawer toggle. Self-contained,
   id-agnostic: works for any .top header with a .top__burger.
   ============================================================ */
(function () {
  "use strict";
  function init() {
    document.querySelectorAll(".top").forEach(function (bar) {
      var burger = bar.querySelector(".top__burger");
      if (burger && !burger.__emzBound) {
        burger.__emzBound = true;
        burger.addEventListener("click", function () {
          var open = bar.classList.toggle("is-menu-open");
          burger.setAttribute("aria-expanded", open ? "true" : "false");
        });
      }
      if (!bar.__emzScroll) {
        bar.__emzScroll = true;
        var onScroll = function () { bar.classList.toggle("is-scrolled", window.scrollY > 8); };
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
      }
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
